import LotteriesList from "@/components/LotteriesList.tsx";
import { useEffect } from "react";
import { setTitle } from "@/hooks/useHeader.ts";
import { useTranslation } from "@/i18n";

const Raffles = () => {
  const { t } = useTranslation();
  useEffect(() => {
    setTitle(t("raffles.title"));
  }, [t]);
  return <LotteriesList />;
};

export default Raffles;
